export default "__VITE_ASSET__ChAvyRQS__";